import React from 'react';

// mycoachhub.in wordmark. The icon PNG has white strokes, so on light
// backgrounds it sits on a navy tile; the wordmark is live text so it stays
// crisp and recolours with the surface it is on.
// iconOnlyOnMobile: phone widths show just the icon; the wordmark appears from sm (640px) up.
export default function SiteLogo({ variant = 'dark', size = 'md', className = '', iconOnlyOnMobile = false }) {
  const onDark = variant === 'dark';
  const iconSize = size === 'lg' ? 'h-14 w-14' : size === 'sm' ? 'h-9 w-9' : 'h-12 w-12';
  const textSize = size === 'lg' ? 'text-[38px]' : size === 'sm' ? 'text-xl' : 'text-[26px] sm:text-[30px]';

  return (
    <span className={`inline-flex items-end gap-0.5 ${className}`}>
      <span className={`${iconSize} flex-shrink-0 ${onDark ? '' : 'rounded-lg bg-brand-ink p-1'}`}>
        <img src="/logo-icon.png" alt="" width="40" height="38" className="h-full w-full object-contain" />
      </span>
      <span aria-hidden="true" className={`${iconOnlyOnMobile ? 'hidden sm:inline' : ''} font-cabinet font-black tracking-tight leading-none pb-0.5 ${textSize} ${onDark ? 'text-white' : 'text-brand-ink'}`}>
        <span className="text-brand-gold">y</span>coachhub.in
      </span>
      <span className="sr-only">mycoachhub.in home</span>
    </span>
  );
}
